import React from "react";
import { Invite } from "../components/Invite/Invite";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function InvitePage() {
  return (
    <Page>
      <div className="page-layout page-layout--animated">
        <div className="page-content">
          <Invite />
        </div>
      </div>
    </Page>
  );
}
